import { useState, useEffect } from "react";
import { DataGrid, ptBR } from "@mui/x-data-grid";
import {
  Grid,
  IconButton,
  Button,
  Tooltip,
  ButtonGroup,
  ListStatus,
} from "../../components";
import shortid from "shortid";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Pesquisar, FiltroAvancadoDialog } from "./components";
import { useImportContext } from "../../contexts/import.context";
import { filtrosUrl } from "../../helpers";

const filtros = {
  orderBy: "updatedAt",
  order: "desc",
  page: "1",
};

const DataGridCustom = (props) => {
  const theme = createTheme(ptBR);
  const { initialCollapses } = useImportContext();
  const [tipoFiltro, setTipoFiltro] = useState("simples");
  const [page, setPage] = useState(0);
  const [busca, setbusca] = useState("");
  const [queryBusca, setQueryBusca] = useState({});
  const [colunas, setColunas] = useState([]);
  const [colunaFiltroSimples, setColunaFiltroSimples] = useState(null);
  const [openFiltroAvancadoDialog, setOpenFiltroAvancadoDialog] =
    useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filtrosAvancados, setFiltrosAvancados] = useState(
    props?.filtros || {},
  );

  useEffect(() => {
    atualizaColunas(props.columns);
  }, [props.columns]);

  const atualizaColunas = (columns) => {
    const colunasComId = columns
      .map((column) => {
        if (column.filtrar) {
          setColunaFiltroSimples(column);
        }
        return {
          ...column,
          id: shortid.generate(),
        };
      })
      .filter((column) => !column?.hide);
    if (!props.disableAcoes) {
      colunasComId.push({
        id: shortid.generate(),
        field: "acoes",
        headerName: "Ações",
        sortable: false,
        flex: 100,
        align: "center",
        headerAlign: "center",
        disableClickEventBubbling: true,
        hideable: false,
        renderCell: (params) => {
          return (
            <div>
              {props.imposto && (
                <IconButton
                  onClick={() => {
                    props.onClickViewImposto(params.id);
                  }}
                >
                  <Tooltip title="Visualizar Imposto" arrow placement="right">
                    <i className="ph-fill ph-eye" style={{ fontSize: 18 }}></i>
                  </Tooltip>
                </IconButton>
              )}
              {props.visualizarShow && !props.editShow && (
                <IconButton
                  onClick={() => {
                    initialCollapses();
                    props.onClickEdit(params.id);
                  }}
                >
                  <Tooltip title="Visualizar" arrow placement="right">
                    <i className="ph-fill ph-eye" style={{ fontSize: 18 }}></i>
                  </Tooltip>
                </IconButton>
              )}
              {props.editShow && (
                <IconButton
                  onClick={() => {
                    initialCollapses();
                    props.onClickEdit(params.id);
                  }}
                >
                  <Tooltip title="Editar" arrow placement="right">
                    <i
                      className="ph-fill ph-pencil"
                      style={{ fontSize: 18 }}
                    ></i>
                  </Tooltip>
                </IconButton>
              )}
              {props.deleteShow && (
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    props.onClickDelete(params.id);
                  }}
                >
                  <Tooltip title="Excluir" arrow placement="right">
                    <i
                      className="ph-fill ph-trash"
                      style={{ fontSize: 18 }}
                    ></i>
                  </Tooltip>
                </IconButton>
              )}
            </div>
          );
        },
      });
    }
    setColunas(colunasComId);
  };

  const handleSortModelChange = (params) => {
    if (props.paginationMode == "server") {
      if (
        params.length &&
        (filtros.orderBy != params[0].field || filtros.order != params[0].sort)
      ) {
        filtros.orderBy = params[0].field == "codigo" ? "id" : params[0].field;
        filtros.order = params[0].sort;
        const retorno = { tipoFiltro };
        if (tipoFiltro == "simples") {
          retorno.filtros = { ...filtros, ...queryBusca };
        } else {
          retorno.filtros = { ...filtros, ...filtrosAvancados };
        }
        props.sendServer(retorno);
      }
    }
  };

  const handlePageChange = (params) => {
    setPage(params.page);
    if (props.paginationMode == "server") {
      filtros.page = (params.page + 1).toString();
      const retorno = { tipoFiltro };
      if (tipoFiltro == "simples") {
        retorno.filtros = { ...filtros, ...queryBusca };
      } else {
        retorno.filtros = { ...filtros, ...filtrosAvancados };
      }
      props.sendServer(retorno);
    }
  };

  const handlePesquisaAvancada = async () => {
    setPage(0);
    setOpenFiltroAvancadoDialog(false);
    setTipoFiltro("avancada");
    filtros.page = "1";
    const retorno = {
      tipoFiltro: "avancada",
      filtros: {
        ...filtros,
        ...filtrosAvancados,
      },
    };
    props.sendServer(retorno);
  };

  const handleSelectableRows = (row) => {
    if (props.isRowSelectable) {
      return props.isRowSelectable(row);
    } else {
      return true;
    }
  };

  const handleChangeStatus = (listStatus, params = null) => {
    const filtrosCustom = params ?? filtrosAvancados;
    const status = listStatus
      .filter((item) => !item.id)
      .map((item) => item.nome);
    const statusPersonalizadoId = listStatus
      .map((item) => item.id)
      .filter((item) => item);

    const temFiltroListStatusCustom = params
      ? Object.keys(params).length > 0
      : false;

    if (
      status.length ||
      statusPersonalizadoId.length ||
      temFiltroListStatusCustom
    ) {
      setTipoFiltro("avancada");
    } else {
      setTipoFiltro("simples");
    }

    const field = props.fieldStatusCustom ?? "status";

    if (status.length) {
      filtros[field] = status;
    } else {
      delete filtros[field];
    }

    if (statusPersonalizadoId.length) {
      filtros.statusPersonalizadoId = statusPersonalizadoId;
    } else {
      delete filtros.statusPersonalizadoId;
    }
    const retorno = {
      tipoFiltro: "avancada",
      filtros: {
        ...filtros,
        ...filtrosCustom,
      },
    };
    props.sendServer(retorno);
  };

  return (
    <>
      {props.listaStatus && (
        <div className="mt-1 mx-2">
          {!props.ListStatusCustom ? (
            <ListStatus
              selectedStatus={selectedStatus}
              setSelectedStatus={setSelectedStatus}
              listaStatus={props.listaStatus}
              handleChangeStatus={handleChangeStatus}
            />
          ) : (
            <props.ListStatusCustom
              selectedStatus={selectedStatus}
              setSelectedStatus={setSelectedStatus}
              listaStatus={props.listaStatus}
              handleChangeStatus={handleChangeStatus}
              filtrosAvancados={filtrosAvancados}
              setFiltrosAvancados={setFiltrosAvancados}
            />
          )}
        </div>
      )}
      <div className="d-flex flex-row justify-content-start align-items-center">
        {props.paginationMode == "server" && !props.noFilter && (
          <>
            {!props.FiltroCustom ? (
              <div className="p-1">
                <Pesquisar
                  setPage={setPage}
                  filtros={filtros}
                  setQueryBusca={setQueryBusca}
                  colunas={props.columns}
                  sendServer={props.sendServer}
                  busca={busca}
                  setbusca={setbusca}
                  setTipoFiltro={setTipoFiltro}
                  tipoFiltro={tipoFiltro}
                  colunaFiltroSimples={colunaFiltroSimples}
                />
              </div>
            ) : (
              props.FiltroCustom
            )}
            {!props.hideFiltroAvancado && (
              <div className="p-1">
                <ButtonGroup
                  variant="outlined"
                  color="inherit"
                  sx={{ height: 52, mt: +!!props.FiltroCustom }}
                >
                  <Button
                    color="inherit"
                    onClick={() => setOpenFiltroAvancadoDialog(true)}
                    size="large"
                  >
                    <span className="text-capitalize">Filtro</span>
                    <i
                      className="ph-bold ph-funnel-simple"
                      style={{
                        color: "#494C62",
                        fontSize: 18,
                        paddingLeft: 10,
                      }}
                    ></i>
                  </Button>
                  {new URLSearchParams(window.location.search).size && (
                    <Tooltip
                      title="Remover filtros"
                      arrow
                      placement="top"
                      className="d-flex"
                    >
                      <Button
                        size="small"
                        color="inherit"
                        onClick={() => {
                          filtrosUrl.delete();
                          setSelectedStatus([]);
                          setFiltrosAvancados({});
                          delete filtros[props.fieldStatusCustom ?? "status"];
                          delete filtros.statusPersonalizadoId;
                          props.sendServer({
                            ...filtros,
                            tipoFiltro: "simples",
                          });
                        }}
                      >
                        <i
                          className="ph-fill ph-trash"
                          style={{ color: "#494C62", fontSize: 15 }}
                        ></i>
                      </Button>
                    </Tooltip>
                  )}
                </ButtonGroup>
              </div>
            )}
          </>
        )}
        {props.extraActions}
      </div>
      <Grid container>
        <Grid item xs={12}>
          <ThemeProvider theme={theme}>
            <DataGrid
              sx={{
                fontFamily: "'Montserrat', sans-serif !important",
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: 600,
                  fontSize: "1rem",
                  color: "#263238",
                },
              }}
              className={props.className}
              rowSelectionModel={props.selectionModel}
              onRowSelectionModelChange={props.onRowSelectionModelChange}
              keepNonExistentRowsSelected={props.keepNonExistentRowsSelected}
              checkboxSelection={props.checkboxSelection}
              isRowSelectable={handleSelectableRows}
              pageSizeOptions={[10]}
              columnVisibilityModel={props.columnVisibilityModel}
              rowModesModel={props.rowModesModel}
              onRowModesModelChange={props.onRowModesModelChange}
              onRowEditStop={props.onRowEditStop}
              hideFooterPagination={props.hideFooterPagination}
              rows={props.rows}
              columns={colunas}
              autoHeight
              onSortModelChange={(params) => handleSortModelChange(params)}
              sortingMode={
                props.paginationMode ? props.paginationMode : "client"
              }
              disableColumnMenu
              getRowId={props.getRowId}
              pageSize={props.pageSize}
              page={page}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: props.nonPaginated ? 100 : 25,
                  },
                },
                sorting: {
                  sortModel: props.sortModel,
                },
                ...props.initialState,
              }}
              rowCount={props.rowCount}
              onPaginationModelChange={(params) => handlePageChange(params)}
              paginationMode={
                props.paginationMode ? props.paginationMode : "client"
              }
              disableRowSelectionOnClick={props.disableRowSelectionOnClick}
              onRowDoubleClick={(params) =>
                (!props.disableAcoes || props.enableRowDoubleClick) &&
                (props.editShow || props.visualizarShow) &&
                props.onClickEdit(params.id)
              }
              onCellKeyDown={props.onCellKeyDown}
              onCellEditStop={props.onCellEditStop}
              // slots={{
              //   toolbar: GridToolbar,
              // }}
              disableColumnFilter={true}
              disableDensitySelector={true}
              getCellClassName={props.getCellClassName}
              localeText={
                props.noRowsLabel
                  ? { noRowsLabel: props.noRowsLabel }
                  : undefined
              }
            />
          </ThemeProvider>
        </Grid>
      </Grid>
      {!props.noFilter && (
        <FiltroAvancadoDialog
          openFiltroAvancadoDialog={openFiltroAvancadoDialog}
          setOpenFiltroAvancadoDialog={setOpenFiltroAvancadoDialog}
          filtrosAvancados={filtrosAvancados}
          setFiltrosAvancados={setFiltrosAvancados}
          handlePesquisaAvancada={handlePesquisaAvancada}
          FormFiltroAvancado={props.FormFiltroAvancado}
        />
      )}
    </>
  );
};

export default DataGridCustom;
